import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { AdditionalCostQuestionsComponent } from './additional-cost-questions.component';

const routes: Routes = [
  {
    path: '',
    component: AdditionalCostQuestionsComponent,
    data: { title: 'Additional Cost Questions' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdditionalCostQuestionsRoutingModule {}

@NgModule({
  imports: [
    AdditionalCostQuestionsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [AdditionalCostQuestionsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [AdditionalCostQuestionsComponent],
})
export class AdditionalCostQuestionsModule {}
